import request from '@/utils/request'

export function getAdSwitchCfg() {
  return request({
    url: 'api/v1/ad/getAdCfg',
    method: 'get'
  })
}

export function updateAdSwitchCfg(data) {
  return request({
    url: 'api/v1/ad/updateSwitchCfg',
    method: 'post',
    data: data
  })
}

export function updateAdCfg(data) {
  return request({
    url: 'api/v1/ad/updateAdCfg',
    method: 'post',
    data: data
  })
}

export function getAdCfg(data) {
  return request({
    url: 'api/v1/ad/getAdCfgList',
    method: 'post',
    data: data
  })
}

export function delAdCfg(data) {
  return request({
    url: 'api/v1/ad/delAdCfg',
    method: 'delete',
    data: data
  })
}

